import React from 'react'
import { cn } from 'utils/cn'
import { Button } from 'components/ui'
import { useCookieConsent } from '../../../hooks/useCookieConsent'
import { CookiePreferencesModal } from './CookiePreferencesModal'
import { LEGAL_COOKIES_URL } from '../../../constants/links'

export const CookieBanner: React.FC = () => {
  const {
    ready,
    hasConsented,
    preferences,
    preferencesOpen,
    acceptAll,
    declineAll,
    savePreferences,
    openPreferences,
    closePreferences,
  } = useCookieConsent()

  if (!ready || (hasConsented && !preferencesOpen)) return null

  return (
    <>
      {!hasConsented && (
        <div className="fixed bottom-6 right-6 z-[1100] w-[380px]">
          <div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-[0_2px_16px_rgba(0,0,0,0.08)] dark:border-gray-600 dark:bg-gray-800">
            <p
              className={cn(
                'text-content-secondary',
                'text-[13px] leading-snug text-gray-500 dark:text-gray-400',
              )}
            >
              We use cookies to improve your experience and analyze traffic.{' '}
              <a
                href={LEGAL_COOKIES_URL}
                className={cn(
                  'text-content-muted transition-colors hover:text-content-secondary focus-visible:outline-none',
                  'text-inherit underline underline-offset-2 hover:text-primary',
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </p>
            <div className={cn('flex flex-row items-center', 'mt-4 gap-2')}>
              <Button
                size="xs"
                colorScheme="accent"
                className="rounded-md px-4"
                onClick={acceptAll}
              >
                Accept
              </Button>
              <Button
                size="xs"
                variant="outline"
                className="rounded-md border-gray-200 px-4 dark:border-gray-600"
                onClick={declineAll}
              >
                Decline
              </Button>
              <button
                onClick={openPreferences}
                className={cn(
                  'text-content-muted transition-colors hover:text-content-secondary focus-visible:outline-none',
                  'ml-auto text-[13px] text-gray-500 no-underline hover:text-inherit dark:text-gray-400',
                )}
              >
                Settings
              </button>
            </div>
          </div>
        </div>
      )}
      <CookiePreferencesModal
        isOpen={preferencesOpen}
        onClose={closePreferences}
        initialAnalytics={hasConsented ? preferences.analytics : true}
        onSave={savePreferences}
      />
    </>
  )
}
